<template>
  <button
    class="action"
    :class="classObject"
    :type="type"
    :disabled="disabled"
    @click="onClick"
  >
    <span class="action__inner">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: 'CAction',

  props: {
    color: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    square: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button'
    },
    textTransform: {
      type: String,
      default: 'uppercase'
    }
  },

  emits: ['click'],

  computed: {
    classObject () {
      return {
        'action--square': this.square,
        'action--primary': this.color === 'primary',
        'action--primary-dark': this.color === 'primary-dark',
        'action--primary-inverse': this.color === 'primary-inverse',
        'action--primary-inverse-dark': this.color === 'primary-inverse-dark',
        'action--secondary': this.color === 'secondary',
        'action--secondary-dark': this.color === 'secondary-dark',
        'action--secondary-inverse': this.color === 'secondary-inverse',
        'action--secondary-inverse-dark': this.color === 'secondary-inverse-dark',
        'action--tertiary': this.color === 'tertiary',
        'action--payment': this.color === 'payment',
        'action--uppercase': this.textTransform === 'uppercase'
      }
    }
  },

  methods: {
    onClick (event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.action {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%; // Fix IE flexbox text overflow
  padding: 0;

  font-weight: 500;
  line-height: 1.4;
  text-decoration: none;
  text-align: center;
  hyphens: auto;
  color: $color-secondary-dark;

  background-color: $color-neutral;
  border: none;
  border-radius: 1em;

  cursor: pointer;

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &.is-active {
    color: #fff;
    background-color: $color-secondary-dark;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .icon {
    flex-shrink: 0;
    margin: 0 0.25em;
  }
}

.action--square {
  .icon {
    margin: 0;
  }
}

.action--primary {
  color: #fff;
  background-color: $color-primary;
}

.action--primary-dark {
  color: #fff;
  background-color: $color-primary-dark;
}

.action--primary-inverse {
  color: $color-primary;
  background-color: #fff;

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &.is-active {
    background-color: $color-primary;
  }
}

.action--primary-inverse-dark {
  color: $color-primary-dark;
  background-color: #fff;

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &.is-active {
    background-color: $color-primary-dark;
  }
}

.action--secondary {
  color: #fff;
  background-color: $color-secondary;
}

.action--secondary-dark {
  color: #fff;
  background-color: $color-secondary-dark;

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &.is-active {
    color: $color-secondary-dark;
    background-color: $color-neutral;
  }
}

.action--secondary-inverse {
  color: $color-secondary;
  background-color: #fff;

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &.is-active {
    background-color: $color-secondary;
  }
}

.action--secondary-inverse-dark {
  color: $color-secondary-dark;
  background-color: #fff;

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &.is-active {
    background-color: $color-secondary-dark;
  }
}

.action--tertiary {
  color: #fff;
  background-color: $color-tertiary;
}

.action--payment {
  background-color: $color-neutral;

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &.is-active {
    background-color: $color-muted;
  }
}

.action--uppercase {
  text-transform: uppercase;
}

.action__inner {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 2em;
  padding: 0.3125em 0.75em;

  .action--square & {
    padding: 0.3125em 0.5em;
  }
}
</style>
